const TERM_ROUTE = '/term'
const TERM_OPTIONS_ROUTE = `${TERM_ROUTE}/list`

export { TERM_ROUTE, TERM_OPTIONS_ROUTE }
